import { render, staticRenderFns } from "./bankMemberTab.vue?vue&type=template&id=92cc8fc4&lang=pug"
import script from "./bankMemberTab.vue?vue&type=script&lang=js"
export * from "./bankMemberTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports